"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HooksContext = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var HooksContext = /*#__PURE__*/(0, _react.createContext)({
  useTranslation: _reactI18next.useTranslation
});
exports.HooksContext = HooksContext;